import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { CustomerType } from '../enums/customer-type.enum';

export class CustomerInfo {
  id: number;
  name: string;
  phone: string;
  countryPhoneCode: string;
  email: string;
  cpf?: string;
  type?: CustomerType;
  phoneFormatted?: string;

  //aux view
  showInputCpf?: boolean;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    this.countryPhoneCode = UtilHelper.unmask(this.countryPhoneCode || '55');
    if (this.phone) {
      if (UtilHelper.unmask(this.countryPhoneCode) == '55') {
        this.phone = UtilHelper.mask(
          this.phone,
          this.phone.length > 10 ? '(99) 99999-9999' : '(99) 9999-9999'
        );
        this.phoneFormatted = this.phone;
      } else {
        this.phoneFormatted = `+${UtilHelper.unmask(this.countryPhoneCode)} ${this.phone}`;
      }
    }
  }

  toJsonUpdate(): any {
    const data: any = {
      id: this.id,
      name: this.name,
      countryPhoneCode: this.countryPhoneCode,
      cpf: this.cpf,
      phone: this.phone,
    };
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/customers/models/customer-info.model.ts